import { ContributorGroupType } from '@/features/contributorGroups/constants'
import { PRApprovalType, RoleInOffer } from '@eapproval/offer-shared'
import { ApprovalInvitationStatus, PRApprovalStatus } from '..'

export const offerGCPRGroupPolicyType = {
  GCPR_EDIT: 'GCPR_EDIT',
  GCPR_EDIT_LOGISTIC: 'GCPR_EDIT_LOGISTIC',
  GCPR_APPROVAL: 'GCPR_APPROVAL',
  GCPR_BUY_NOW: 'GCPR_BUY_NOW',
  GCPR_PR_SUBMISSION: 'GCPR_PR_SUBMISSION',
  GCPR_REPLY_INVITATION: 'GCPR_REPLY_INVITATION',
}

const GCPR_EDIT_ROLES = [
  RoleInOffer.CREATOR,
  RoleInOffer.INITIATOR,
  RoleInOffer.BOOKING_COMMERCIAL_PROJECT_MANAGER,
  RoleInOffer.ENGINEER,
  RoleInOffer.TEAM_ASSISTANT,
  RoleInOffer.DEPT_USER,
  RoleInOffer.BOOKING_MANAGER,
]

const GCPR_RELATED_ROLES = [...GCPR_EDIT_ROLES, RoleInOffer.GCPR_APPROVER]

export const offerGCPRGroupPolicies = {
  [offerGCPRGroupPolicyType.GCPR_EDIT]: {
    view: true,
    edit: ({ offer, user, allRoles }) => {
      if (allRoles?.some((role) => GCPR_EDIT_ROLES.includes(role))) return true
      const pmDefaultDept = offer?.booking?.projectManager?.defaultDepartment
      const userDefaultDept = user?.defaultDepartment
      return !!(pmDefaultDept && userDefaultDept && String(pmDefaultDept) === String(userDefaultDept))
    },
  },
  [offerGCPRGroupPolicyType.GCPR_EDIT_LOGISTIC]: {
    view: true,
    edit: ({ role, offer, isFreeze, userGroup }) => {
      return role === RoleInOffer.GCPR_APPROVER && userGroup === ContributorGroupType.LOGISTIC
    },
  },
  [offerGCPRGroupPolicyType.GCPR_APPROVAL]: {
    view: true,
    edit: ({ allRoles, offer, isFreeze, userGroup, roleDetail }) => {
      return allRoles.includes(RoleInOffer.GCPR_APPROVER)
    },
  },
  [offerGCPRGroupPolicyType.GCPR_BUY_NOW]: {
    view: true,
    edit: ({ allRoles, offer, isFreeze, userGroup, roleDetail }) => {
      return (
        allRoles.includes(RoleInOffer.GCPR_APPROVER) && roleDetail?.type === PRApprovalType.COMMERCIAL_PROJECT_MANAGER
      )
    },
  },
  [offerGCPRGroupPolicyType.GCPR_PR_SUBMISSION]: {
    view: true,
    edit: ({ allRoles, offer, isFreeze, userGroup, roleDetail }) => {
      return allRoles?.some((role) => GCPR_RELATED_ROLES.includes(role))
    },
  },
  [offerGCPRGroupPolicyType.GCPR_REPLY_INVITATION]: {
    view: true,
    edit: ({ allRoles, roleDetail, allRoleDetails }) => {
      return (
        allRoles?.some((role) => role === RoleInOffer.GCPR_APPROVER_INVITEE) &&
        allRoleDetails.some((role) => role.roleDetail?.status === ApprovalInvitationStatus.INVITED)
      )
    },
  },
}
